// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import './secondarybutton.scss'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const SecondaryButton = ({ labelStyle, btnText, containerStyle, onPress, image, imageAlt, imageStyle, id }) => {
  const onButtonCLick = () => {
    onPress()
  }
  return (
    <div
      id={id}
      className={image ? 'secondary-button-container secondary-button-image-container' : 'secondary-button-container'}
      style={containerStyle}
      onClick={onButtonCLick}>
      {image != null && <img src={image} alt={imageAlt} className='secondary-image-icon' style={imageStyle} />}
      <label style={labelStyle} className='secondary-button-text'>
        {btnText}
      </label>
    </div>
  )
}
